import AxiosWrapper from '@/helpers/axios-wrapper'


/**
 * @returns Promise
 */
export function list() {
    return AxiosWrapper('/teams/variables/list/', {});
}

/**
 * @returns Promise
 */
export function detail() {
    return AxiosWrapper('/teams/variables/detail/', {});
}

/**
 * @returns Promise
 */
export function remove(formData) {
    return AxiosWrapper('/teams/variables/remove/', {headers: {"Content-Type": "multipart/form-data"}}, 'POST', formData);
}